module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_7.0d6b59fd.png";